module.exports = __webpack_public_path__ + "static/bgf_img02@2x-18922fc5da7d188f5c5b98b019c1463f.jpg";